export default "__VITE_ASSET__pDLBJKs0__"